import type { Webhook } from "@repo/shared/types";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useT } from "@/lib/i18n/use-t";
import { WebhookDialog } from "./webhook-dialog";
import { T } from "./webhook-wrapper.i18n";
import { WebhooksTable } from "./webhooks-table";

type WebhookWrapperProps = {
  webhooks: Webhook[];
  mutate: () => void;
};

export function WebhookWrapper({ webhooks, mutate }: WebhookWrapperProps) {
  const t = useT(T);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingWebhook, setEditingWebhook] = useState<Webhook | null>(null);

  const handleCreate = () => {
    setEditingWebhook(null);
    setDialogOpen(true);
  };

  const handleEdit = (webhook: Webhook) => {
    setEditingWebhook(webhook);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setEditingWebhook(null);
  };

  return (
    <>
      <div className="flex justify-end mb-4">
        <Button onClick={handleCreate}>{t.addWebhook}</Button>
      </div>

      <WebhooksTable webhooks={webhooks} onEdit={handleEdit} mutate={mutate} />

      <WebhookDialog
        open={dialogOpen}
        webhook={editingWebhook}
        onClose={handleDialogClose}
        mutate={mutate}
      />
    </>
  );
}
